module.exports = __webpack_public_path__ + "img/payqr.dec63c20.png";